import request from '@/utils/request'

/**
 * 发送短信验证码
 * @param {Object} data
 * @param {String} data.mobile 手机号
 * @param {String} data.type image：图片验证码；aliyun：智能验证码
 * @param {Object} data.key 验证码标识,图片验证码时必须参数
 * @param {Object} data.code 验证码字符串,图片验证码时必须参数
 * @param {Object} data.captchaVerifyParam 验证参数,智能验证码时必须参数
 * @param {Object} data.sceneId 场景ID,智能验证码时必须参数
 */
export function sendSmsCode(data) {
  return request({
    url: '/v1/utils/send-sms-code',
    method: 'post',
    data
  })
}
